"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ErrorNotification = require("./ErrorNotification");
Object.keys(_ErrorNotification).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorNotification[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorNotification[key];
    }
  });
});
